import { call, put, takeLatest } from "redux-saga/effects";
import {
  addDepartmentFailure,
  addDepartmentSuccess,
  deleteDepartmentFailure,
  deleteDepartmentSuccess,
  fetchDepartmentFailure,
  fetchDepartmentsFailure,
  fetchDepartmentsSuccess,
  fetchDepartmentSuccess,
  updateDepartmentFailure,
  updateDepartmentSuccess,
} from "./departmentAction";
import {
  addDepartmentEffect,
  deleteDepartmentEffect,
  editDepartmentEffect,
  listDepartmentEffect,
  viewDepartmentEffect,
} from "./departmentEffect";
import {
  ADD_DEPARTMENT_REQUEST,
  DELETE_DEPARTMENT_REQUEST,
  FETCH_DEPARTMENT_REQUEST,
  FETCH_LIST_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_REQUEST,
} from "./departmentType";

function* fetchDepartmentsSaga(action) {
  try {
    const departments = yield call(listDepartmentEffect, action.payload);
    
    yield put(fetchDepartmentsSuccess(departments.data));
  } catch (error) {
  
    yield put(fetchDepartmentsFailure(error.message));
  }
}

function* fetchDepartmentSaga(action) {
  try {
    const department = yield call(viewDepartmentEffect, action.payload.departmentId);
    yield put(fetchDepartmentSuccess(department));
  } catch (error) {
    yield put(fetchDepartmentFailure(error.message));
  }
}

function* addDepartmentSaga(action) {
  try {
    const newDepartment = yield call(addDepartmentEffect, action.payload.departmentData);
    yield put(addDepartmentSuccess(newDepartment));
  } catch (error) {
    yield put(addDepartmentFailure(error.message));
  }
}

function* updateDepartmentSaga(action) {
  try {
    const updatedDepartment = yield call(
      editDepartmentEffect,
      action.payload.departmentId,
      action.payload.departmentData
    );
    yield put(updateDepartmentSuccess(updatedDepartment));
  } catch (error) {
    yield put(updateDepartmentFailure(error.message));
  }
}

function* deleteDepartmentSaga(action) {
  try {
    yield call(deleteDepartmentEffect, action.payload.departmentId);
    yield put(deleteDepartmentSuccess(action.payload.departmentId));
  } catch (error) {
    yield put(deleteDepartmentFailure(error.message));
  }
}

export function* departmentSagas() {
  yield takeLatest(FETCH_LIST_DEPARTMENT_REQUEST, fetchDepartmentsSaga);
  yield takeLatest(FETCH_DEPARTMENT_REQUEST, fetchDepartmentSaga);
  yield takeLatest(ADD_DEPARTMENT_REQUEST, addDepartmentSaga);
  yield takeLatest(UPDATE_DEPARTMENT_REQUEST, updateDepartmentSaga);
  yield takeLatest(DELETE_DEPARTMENT_REQUEST, deleteDepartmentSaga);
}